import { isEmpty, get, isEqual } from 'lodash';
import { CONTEXT } from '../../config';
import authenticationRoutes from '../../routes/authentication';

// common actions import
import { beginAjaxCallAction, endAjaxCallAction, apiErrorResponseAction } from '../common';

import {
  FETCH_GUEST_ORDERS,
  UPDATE_ORDER_STATUS,
  SIGN_IN_SUCCESS,
  CHECK_GUEST_ORDERS,
  BEGIN_NOTIFICATION_LOADER,
  END_NOTIFICATION_LOADER,
  FETCH_ORDER_HISTORY,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  GET_RESTAURANT_MENU,
  GET_MENU_CUSTOMIZATIONS,
  FETCH_MENU_ITEM_CUSTOMIZATIONS,
  TIMER_INITIATED,
  GET_GUESTS_LIST,
  GET_GUEST_DETAILS,
  GET_GUEST_ORDERS,
  DISPATCH_RESTAURANT_SETTINGS,
  CLEAR_RESTAURANT_SETTINGS,
  UPDATE_RESTAURANT_ASSISTANCE_SERVICES,
  GET_CURRENT_ASSISTANCES,
  DISPATCH_ATTENDED_ASSISTANCES,
  GET_ORDER_SUMMARY_DATA,
  FETCH_OFFERS,
  DISPATCH_OFFER_LIST,
  OFFER_DATA,
  FETCH_MENU_CATEGORIES,
  GET_LOCALITIES_BY_CITY,
  FETCH_RESTAURANT_TABLES,
  UPDATE_RESTAURANT_ADDITIONAL_CHARGES,
  ADD_RESTAURANT_ADDITIONAL_CHARGES,
  DELETE_RESTAURANT_ADDITIONAL_CHARGES,
  UPDATE_RESTAURANT_NOTIFICATION_EMAILS,
  FETCH_OFFER_GUESTS,
  GET_UPSELL_ITEM,
  GET_RESTAURANT_UPSELL,
  FETCH_RESTAURANT_CASH_CARD,
  FETCH_CARD_LIST,
  CLEAR_CARD_LIST,
  FETCH_CARD_DETAILS,
  CLEAR_CARD_DETAILS,
  FETCH_GUEST_CASH_CARD_TRANSACTIONS,
  CLEAR_GUEST_CASH_CARD_TRANSACTIONS,
  FETCH_ORDER_CANCELLATION_REASONS,
  CLEAR_ORDER_CANCELLATION_REASONS,
  FETCH_RESTAURANT_SUBSCRIPTION_DETAILS,
  CLEAR_RESTAURANT_SUBSCRIPTION_DETAILS,
  FETCH_RESTAURANT_SUBSCRIPTION_PLAN_HISTORY,
  CLEAR_RESTAURANT_SUBSCRIPTION_PLAN_HISTORY,
  FETCH_SAAS_PLANS,
  DISPATCH_PROGRESSIVE_WEB_APP_DATA,
  CLEAR_PROGRESSIVE_WEB_APP_DATA,
  UPDATE_GUEST_ORDER,
  GET_ENTITY_MAPPING_DATA,
  UPDATE_ENTITY_MAPPING_DATA,
  FETCH_POS_SYNC_STATUS_BY_ORDER_IDS,
  CLEAR_POS_SYNC_STATUS_BY_ORDER_IDS,
  DISPATCH_POS_SYNC_STATUS,
  VALIDATE_DEAL_DATA,
  REDEEMED_DEAL_DATA,
  GET_RESTAURANT_POS_INTEGRATIONS,
  ClEAR_RESTAURANT_POS_INTEGRATIONS,
  CLEAR_RESTAURANT_INTEGRATIONS,
  FETCH_BULK_POS_SYNC_EVENTS,
  CLEAR_BULK_POS_SYNC_EVENTS,
  CLEAR_ENTITY_MAPPING_DATA,
  FETCH_EXTERNAL_POS_MENU_ITEMS,
} from './actionTypes';
import {
  getCurrentOrders,
  updateOrderStatusApi,
  checkCurrentOrders,
  getOrderHistory,
  getOrderById,
  updateTableApi,
  getRestaurantMenuApi,
  updateMenuItemApi,
  createMenuItemApi,
  fetchMenuItemDetailsApi,
  getMenuCustomizationsApi,
  updateMenuCustomizationsApi,
  fetchMenuItemCustomizationsApi,
  getGuestsListApi,
  getGuestDetailsApi,
  getGuestOrdersApi,
  updateRestaurantSettingsApi,
  updateRestaurantAssistanceServicesApi,
  getCurrentAssistancesApi,
  attendAssistancesApi,
  getRestaurantDataApi,
  getOrderSummaryDataApi,
  fetchOffersListApi,
  createOfferApi,
  editOfferApi,
  deleteOfferApi,
  validateOfferCodeApi,
  getOfferDetailsApi,
  fetchMenuCategoriesApi,
  getLocalitiesByCityApi,
  verifyCustomKeyApi,
  getCustomLinksApi,
  createCustomLinkApi,
  fetchMenuCategoryDetailsApi,
  updateMenuCategoriesApi,
  createMenuCategoriesApi,
  fetchRestaurantTablesApi,
  updateRestaurantAdditionalChargesApi,
  addRestaurantAdditionalChargesApi,
  deleteRestaurantAdditionalChargesApi,
  exportGuestListApi,
  exportOrderHistoryApi,
  exportOrderItemsReportApi,
  fetchRestaurantNotificationEmailsApi,
  updateRestaurantNotificationEmailsApi,
  creatUpsellItemApi,
  getUpsellDataApi,
  fetchGuestListApi,
  fetchOfferGuestApi,
  updateUpsellItemsApi,
  getRestaurantUpsellApi,
  fetchRestaurantCashCardApi,
  createRestaurantCashCardApi,
  updateRestaurantCashCardApi,
  fetchCardListApi,
  fetchGuestCashCardDetailsApi,
  fetchGuestCashCardTransactionsApi,
  checkFeaturesStatusApi,
  findGuestByPhoneNumberApi,
  sendOtpApi,
  createNewGuestApi,
  addNewGuestCashCardApi,
  rechargeGuestCashCardApi,
  updateGuestDetailsApi,
  fetchOrderCancellationReasonsApi,
  fetchCustomizedItemDetailsApi,
  createCustomizedGroupItemApi,
  createCustomizedGroupApi,
  deleteCustomizedItemApi,
  deleteCustomizedGroupApi,
  editCustomizedGroupApi,
  editCustomizedGroupItemApi,
  deleteMenuCategoryApi,
  deleteMenuItemApi,
  fetchRestaurantSubscriptionApi,
  fetchRestaurantSubscriptionHistoryApi,
  fetchSaaSPlansApi,
  fetchProgressiveWebAppDataApi,
  createProgressiveWebAppApi,
  updateProgressiveWebAppApi,
  registerSubscriptionRequestApi,
  updateGuestOrderApi,
  goLiveRestaurantApi,
  getEntityMappingDataApi,
  updateEntityMappingDataApi,
  fetchPOSSyncStatusByOrderIdsApi,
  validateCouponApi,
  redeemCouponApi,
  getRestaurantIntegrationsApi,
  fetchBulkPOSSyncEventsApi,
  fetchExternalPOSMenuItemsApi,
} from '../../api';

import {
  clearAuthenticationDataAction,
  dispatchIsPseudoSignInAction,
  logoutCurrentDeviceSilentlyAction,
} from '../authentication';
import { getFeatureStatus } from '../../selectors';
import { readFudrAdminData } from '../../utils/helpers';

export const initiateTimerAction = (isTimerInitiatedFlag) => (dispatch) => {
  dispatch({
    type: TIMER_INITIATED,
    isTimerInitiated: isTimerInitiatedFlag,
  });
};

export const getCurrentOrdersAction = (accessToken, restaurantId) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const order = await getCurrentOrders(accessToken, restaurantId)
      .then((response) => {
        dispatch({
          type: FETCH_GUEST_ORDERS,
          order: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return order;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const checkCurrentOrdersAction =
  ({ accessToken, restaurantId, history, authData }) =>
  async (dispatch) => {
    const fudrAdminData = readFudrAdminData();
    const signedInUsername = get(authData, 'user.name', '');
    const userBucket = signedInUsername ? fudrAdminData[signedInUsername] : undefined;
    if (userBucket && Object.prototype.hasOwnProperty.call(userBucket, 'authData')) {
      let orderEvent = await checkCurrentOrders(accessToken, restaurantId);
      if (!isEmpty(orderEvent)) {
        dispatch({
          type: CHECK_GUEST_ORDERS,
          orderEvent,
        });
      }
      return orderEvent;
    }
  };

export const updateOrderStatusAction = (orderUpdateReqBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const orderStatus = await updateOrderStatusApi(orderUpdateReqBody)
      .then((response) => {
        dispatch({
          type: UPDATE_ORDER_STATUS,
          orderStatus: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return orderStatus;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

// This action is meant to encompass all update order actions, including updating items in future.
export const updateGuestOrderAction =
  ({ orderId, orderUpdateType, updateGuestOrderReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const updateGuestOrderAPIResponse = await updateGuestOrderApi(
        orderId,
        orderUpdateType,
        updateGuestOrderReqBody,
      )
        .then((response) => {
          dispatch({
            type: UPDATE_GUEST_ORDER,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return updateGuestOrderAPIResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

/**
 *
 * @param {*} updateTableReqBody
 */
export const updateTableAction =
  ({ updateTableReqBody, orderId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updatedTable = await updateTableApi({ updateTableReqBody, orderId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return updatedTable;
    } catch (err) {
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearSignInDataAction =
  ({
    history,
    signedInUsername,
    isPseudoSignIn,
    prefilledData = {},
    accessToken,
    skipSilentLogout = false,
  }) =>
  async (dispatch) => {
    // Fire silent logout in the background so sign-out UX stays immediate even if the
    // network is slow. accessToken is already snapshotted from props for token safety.
    if (!skipSilentLogout) {
      const logoutOpts = accessToken ? { accessToken } : {};
      dispatch(logoutCurrentDeviceSilentlyAction(logoutOpts));
    }
    // After a pseudo-assisted session, keep Redux flag true so post-logout redirect stays on the pseudo sign-in route.
    isPseudoSignIn && dispatch(dispatchIsPseudoSignInAction(true));
    dispatch(clearAuthenticationDataAction({ signedInUsername }));
    dispatch(clearRestaurantSignInDataAction({ history, isPseudoSignIn, prefilledData }));
  };

export const clearRestaurantSignInDataAction =
  ({ history, isPseudoSignIn, prefilledData }) =>
  async (dispatch) => {
    dispatch({
      type: SIGN_IN_SUCCESS,
      authData: {},
    });
    dispatch({
      type: FETCH_GUEST_ORDERS,
      order: {},
    });
    dispatch({
      type: FETCH_ORDER_HISTORY,
      orders: {},
    });
    dispatch({
      type: GET_ORDER_BY_ID_SUCCESS,
      orderById: {},
    });
    dispatch({
      type: CHECK_GUEST_ORDERS,
      orderEvent: {},
    });
    dispatch({
      type: GET_RESTAURANT_MENU,
      restaurantMenu: [],
    });
    dispatch({
      type: GET_MENU_CUSTOMIZATIONS,
      menuCustomizations: [],
    });
    dispatch({
      type: CLEAR_RESTAURANT_SETTINGS,
    });
    dispatch({
      type: DISPATCH_ATTENDED_ASSISTANCES,
      attendedAssistancesArr: [],
    });
    dispatch({
      type: FETCH_MENU_CATEGORIES,
      menuCategories: [],
    });
    dispatch({
      type: DISPATCH_OFFER_LIST,
      offerList: [],
    });
    dispatch({
      type: FETCH_OFFERS,
      offers: {},
    });
    dispatch({
      type: OFFER_DATA,
      offerData: {},
    });
    dispatch({
      type: GET_LOCALITIES_BY_CITY,
      localities: [],
    });
    dispatch({
      type: GET_UPSELL_ITEM,
      upsellMenuItemList: {},
    });
    dispatch({
      type: FETCH_RESTAURANT_TABLES,
      restaurantTables: {},
    });
    dispatch({
      type: CLEAR_RESTAURANT_SUBSCRIPTION_DETAILS,
    });
    dispatch({
      type: CLEAR_RESTAURANT_SUBSCRIPTION_PLAN_HISTORY,
    });

    dispatch(initiateTimerAction(false));
    dispatch(clearProgressiveWebAppDataAction());
    dispatch(clearRestaurantIntegrations());

    // Redirect to the default authentication route upon clearing restaurant signin data. In case of pseudo-signin, take it to pseudo-signin route.
    history.push({
      pathname: `${CONTEXT}/${authenticationRoutes.authentication}${
        !isPseudoSignIn ? `/${authenticationRoutes.containers.signIn}` : `/${authenticationRoutes.containers.pseudoSignIn}`
      }`,
      ...(prefilledData && { state: { prefilledData } }),
    });
  };

export const getOrderHistoryDataAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const orders = await getOrderHistory({ accessToken, url })
      .then((response) => {
        dispatch({
          type: FETCH_ORDER_HISTORY,
          orders: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return orders;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearHistoryDataAction = () => async (dispatch) => {
  dispatch({
    type: FETCH_ORDER_HISTORY,
    orders: {},
  });
};

export const getOrderByIdAction = (accessToken, orderId) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const orderById = await getOrderById(accessToken, orderId)
      .then((response) => {
        dispatch({
          type: GET_ORDER_BY_ID_SUCCESS,
          orderById: get(response, 'data', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return orderById;
  } catch (err) {
    dispatch({
      type: GET_ORDER_BY_ID_FAILURE,
      orderById: {},
    });
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearSelectedOrderAction = () => (dispatch) => {
  dispatch({
    type: GET_ORDER_BY_ID_SUCCESS,
    orderById: {},
  });
};

export const getRestaurantMenuAction =
  ({ restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await getRestaurantMenuApi({ restaurantId })
        .then((response) => {
          dispatch({
            type: GET_RESTAURANT_MENU,
            restaurantMenu: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchMenuCategoryDetailsAction =
  ({ categoryId }) =>
  async (dispatch) => {
    try {
      let menuCateogryDetailsResponse = fetchMenuCategoryDetailsApi({ categoryId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return menuCateogryDetailsResponse;
    } catch (err) {
      console.error(err);
    }
  };

export const updateMenuCategoriesAction =
  ({ updateMenuCategoryReqBody, restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await updateMenuCategoriesApi({ updateMenuCategoryReqBody })
        .then((response) => {
          dispatch(getRestaurantMenuAction({ restaurantId }));
          dispatch(fetchMenuCategoriesAction({ restaurantId }));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
      dispatch(endAjaxCallAction());
    }
  };

export const createMenuCategoriesAction =
  ({ createMenuCategoryReqBody, restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await createMenuCategoriesApi({ createMenuCategoryReqBody })
        .then((response) => {
          dispatch(getRestaurantMenuAction({ restaurantId }));
          dispatch(fetchMenuCategoriesAction({ restaurantId }));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
      dispatch(endAjaxCallAction());
    }
  };

export const createCustomizedGroupAction =
  ({ customizedGroupReqBody, restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await createCustomizedGroupApi({ customizedGroupReqBody })
        .then((response) => {
          dispatch(getMenuCustomizationsAction({ restaurantId }));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const createCustomizedGroupItemAction =
  ({ customizedGroupItemReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await createCustomizedGroupItemApi({ customizedGroupItemReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const editCustomizedGroupItemAction =
  ({ customizedGroupItemReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await editCustomizedGroupItemApi({ customizedGroupItemReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const editCustomizedGroupAction =
  ({ customizedGroupReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await editCustomizedGroupApi({ customizedGroupReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchMenuCategoriesAction =
  ({ restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let menuCategories = await fetchMenuCategoriesApi({ restaurantId })
        .then((response) => {
          dispatch({
            type: FETCH_MENU_CATEGORIES,
            menuCategories: get(response, 'data.categoryHeaders', []),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return menuCategories;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateMenuItemAction =
  ({ updateMenuItemReqBody, restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await updateMenuItemApi({ updateMenuItemReqBody })
        .then((response) => {
          dispatch(getRestaurantMenuAction({ restaurantId }));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const createMenuItemAction =
  ({ createMenuItemReqBody, restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await createMenuItemApi({ createMenuItemReqBody })
        .then((response) => {
          dispatch(getRestaurantMenuAction({ restaurantId }));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchMenuItemDetailsAction =
  ({ menuItemId }) =>
  async (dispatch) => {
    try {
      let response = await fetchMenuItemDetailsApi({ menuItemId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

export const fetchCustomizedItemDetailsAction =
  ({ customizedItemId }) =>
  async (dispatch) => {
    try {
      let response = await fetchCustomizedItemDetailsApi({ customizedItemId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

export const deleteCustomizedItemAction =
  ({ customizedItemId, accessToken }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await deleteCustomizedItemApi({ customizedItemId, accessToken })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const deleteCustomizedGroupAction =
  ({ customizedGroupId, accessToken }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await deleteCustomizedGroupApi({ customizedGroupId, accessToken })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getMenuCustomizationsAction =
  ({ restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let menuCustomizations = await getMenuCustomizationsApi({ restaurantId })
        .then((response) => {
          dispatch({
            type: GET_MENU_CUSTOMIZATIONS,
            menuCustomizations: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return menuCustomizations;
    } catch (err) {
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateMenuCustomizationsAction =
  ({ updateMenuCustomizationsReqBody, restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await updateMenuCustomizationsApi({ updateMenuCustomizationsReqBody })
        .then((response) => {
          dispatch(getMenuCustomizationsAction({ restaurantId }));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (err) {
      dispatch(endAjaxCallAction());
    }
  };

export const deleteCategoryAction =
  ({ accessToken, categoryId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let deleteCategoryResponse = await deleteMenuCategoryApi({ accessToken, categoryId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return deleteCategoryResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const deleteMenuItemAction =
  ({ accessToken, menuItemId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let deleteMenuItemResponse = await deleteMenuItemApi({ accessToken, menuItemId })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return deleteMenuItemResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getGuestsListAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const guestsList = await getGuestsListApi({ accessToken, url })
      .then((response) => {
        dispatch({
          type: GET_GUESTS_LIST,
          guestsList: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return guestsList;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearGuestListAction = () => async (dispatch) => {
  dispatch({
    type: GET_GUESTS_LIST,
    guestsList: {},
  });
};

export const getGuestDetailsAction =
  ({ accessToken, restaurantId, guestId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const guestDetails = await getGuestDetailsApi({ accessToken, restaurantId, guestId })
        .then((response) => {
          dispatch({
            type: GET_GUEST_DETAILS,
            guestDetails: response,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });
      return guestDetails;
    } catch (err) {
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearGuestDetailsDataAction = () => async (dispatch) => {
  dispatch({
    type: GET_GUEST_DETAILS,
    guestDetails: {},
  });
};

export const getGuestOrdersAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const guestOrders = await getGuestOrdersApi({ accessToken, url })
      .then((response) => {
        dispatch({
          type: GET_GUEST_ORDERS,
          guestOrders: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return guestOrders;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearGuestOrdersDataAction = () => async (dispatch) => {
  dispatch({
    type: GET_GUEST_ORDERS,
    guestOrders: {},
  });
};

export const updateRestaurantSettingsAction =
  ({ accessToken, updateRestaurantSettingsReqBody, restaurantId, depthParam }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateRestaurantSettingsAPIResponse = await updateRestaurantSettingsApi({
        accessToken,
        updateRestaurantSettingsReqBody,
      })
        .then((response) => {
          getRestaurantDataApi({ accessToken, restaurantId, depthParam })
            .then((restaurantDataResponse) =>
              dispatch({
                type: DISPATCH_RESTAURANT_SETTINGS,
                restaurantData: get(restaurantDataResponse, 'data', {}),
              }),
            )
            .catch((errorResponse) => {
              dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
            });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return updateRestaurantSettingsAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateRestaurantAssistanceServicesAction =
  ({ accessToken, updateRestaurantAssistanceServicesReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const assistanceServicesMasterDataAPIResponse = await updateRestaurantAssistanceServicesApi({
        accessToken,
        updateRestaurantAssistanceServicesReqBody,
      })
        .then((response) => {
          dispatch({
            type: UPDATE_RESTAURANT_ASSISTANCE_SERVICES,
            restaurantAssistanceServices: get(response, 'data.restaurantAssistanceServices', []),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return assistanceServicesMasterDataAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getCurrentAssistancesAction =
  ({ accessToken, assistancesReqBody }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: BEGIN_NOTIFICATION_LOADER,
        showNotificationLoader: true,
      });
      const assistancesData = await getCurrentAssistancesApi({ accessToken, assistancesReqBody });
      dispatch({
        type: GET_CURRENT_ASSISTANCES,
        assistancesData: get(assistancesData, 'serviceAssistances', []),
        assistancesCount: get(assistancesData, 'serviceAssistances.length', 0),
      });
    } catch (err) {
    } finally {
      dispatch({
        type: END_NOTIFICATION_LOADER,
        showNotificationLoader: false,
      });
    }
  };

export const attendAssistancesAction =
  ({ attendAssistancesReqBody, attendedAssistancesArr, assistancesData }) =>
  async (dispatch) => {
    try {
      const attendedAssistancesResponse = await attendAssistancesApi({ attendAssistancesReqBody });
      if (isEqual(get(attendedAssistancesResponse, 'status'), 200)) {
        dispatch({
          type: DISPATCH_ATTENDED_ASSISTANCES,
          attendedAssistancesArr,
        });
        dispatch({
          type: GET_CURRENT_ASSISTANCES,
          assistancesData,
          assistancesCount:
            assistancesData &&
            assistancesData.filter((el) => !attendedAssistancesArr.includes(el.id)).length,
        });
      }
    } catch (err) {}
  };

export const clearAttendedAssistancesAction = () => async (dispatch) => {
  dispatch({
    type: DISPATCH_ATTENDED_ASSISTANCES,
    attendedAssistancesArr: [],
  });
};

export const getRestaurantDataAction =
  ({ restaurantId, accessToken, depthParam }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const restaurantDataAPIResponse = await getRestaurantDataApi({
        restaurantId,
        accessToken,
        depthParam,
      })
        .then((response) => {
          dispatch({
            type: DISPATCH_RESTAURANT_SETTINGS,
            restaurantData: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return restaurantDataAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getOrderSummaryDataAction =
  ({ orderSummaryReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const orderSummaryData = await getOrderSummaryDataApi({ orderSummaryReqBody });
      dispatch({
        type: GET_ORDER_SUMMARY_DATA,
        orderSummaryData: get(orderSummaryData, 'data', {}),
      });
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchMenuItemCustomizationsAction = (restaurantId, menuItemId) => async (dispatch) => {
  const customization = await fetchMenuItemCustomizationsApi({ restaurantId, menuItemId });
  dispatch({
    type: FETCH_MENU_ITEM_CUSTOMIZATIONS,
    customization,
  });
};

export const clearCustomizationAction = () => async (dispatch) => {
  dispatch({
    type: FETCH_MENU_ITEM_CUSTOMIZATIONS,
    customization: [],
  });
};

export const dispatchOfferListAction =
  ({ offerList }) =>
  async (dispatch) => {
    dispatch({
      type: DISPATCH_OFFER_LIST,
      offerList,
    });
  };

export const fetchOffersListAction =
  ({ accessToken, url }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const offerList = await fetchOffersListApi({ accessToken, url })
        .then((response) => {
          dispatch({
            type: DISPATCH_OFFER_LIST,
            offerList: get(response, 'data._embedded.offers', []),
          });
          dispatch({
            type: FETCH_OFFERS,
            offers: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return offerList;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const createOfferAction =
  ({ accessToken, offerParams }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const offerData = await createOfferApi({ accessToken, offerParams })
        .then((response) => {
          dispatch({
            type: OFFER_DATA,
            offerData: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return offerData;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const editOfferAction =
  ({ accessToken, offerParams }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const offerData = await editOfferApi({ accessToken, offerParams })
        .then((response) => {
          dispatch({
            type: OFFER_DATA,
            offerData: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return offerData;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const deleteOfferAction =
  ({ accessToken, offerParams }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const deleteOfferData = await deleteOfferApi({ accessToken, offerParams })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return deleteOfferData;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const validateOfferCodeAction =
  ({ validateOfferCodeParams }) =>
  () =>
    validateOfferCodeApi({ validateOfferCodeParams });

export const getOfferDetailsAction =
  ({ accessToken, params }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const offerData = await getOfferDetailsApi({ accessToken, params })
        .then((response) => {
          dispatch({
            type: OFFER_DATA,
            offerData: response,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return offerData;
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearOfferDataAction = () => async (dispatch) => {
  dispatch({
    type: OFFER_DATA,
    offerData: {},
  });
};

export const invalidateOffersDataAction = () => async (dispatch) => {
  dispatch({
    type: DISPATCH_OFFER_LIST,
    offerList: [],
  });
  dispatch({
    type: FETCH_OFFERS,
    offers: [],
  });
};

/**
 * Action to - Get localities by city and search input
 *
 * @param {object} [cityId] City's identification key
 */
export const getLocalitiesByCityAction =
  ({ cityId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const localitiesByCityAPIResponse = await getLocalitiesByCityApi({ cityId })
        .then((response) => {
          dispatch({
            type: GET_LOCALITIES_BY_CITY,
            localities: get(response, 'data.localities', []),
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return localitiesByCityAPIResponse;
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const verifyCustomKeyAction =
  ({ customKey, keyType }) =>
  async (dispatch) => {
    try {
      const verifyCustomKeyAPIResponse = await verifyCustomKeyApi({ customKey, keyType })
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return verifyCustomKeyAPIResponse;
    } catch (error) {
      console.error(error);
    }
  };

export const getCustomLinksAction =
  ({ customLinkParams, customLinkSearchUrl }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const customLinksAPIResponse = await getCustomLinksApi({
        customLinkParams,
        customLinkSearchUrl,
      })
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return customLinksAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const createCustomLinkAction =
  ({ customLinkParams }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const createCustomLinkAPIResponse = await createCustomLinkApi({ customLinkParams })
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return createCustomLinkAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchRestaurantTablesAction =
  ({ page, restaurantId, tableType, includeRunningOrders, qrCodeDefaultPageSize, defaultSort }) =>
  async (dispatch) => {
    dispatch(beginAjaxCallAction());
    fetchRestaurantTablesApi({
      page,
      restaurantId,
      tableType,
      includeRunningOrders,
      qrCodeDefaultPageSize,
      defaultSort,
    })
      .then((response) => {
        dispatch({
          type: FETCH_RESTAURANT_TABLES,
          restaurantTables: get(response, 'data', {}),
        });
      })
      .catch((error) => {
        dispatch(apiErrorResponseAction(get(error, 'response.data', {})));
      })
      .finally(() => dispatch(endAjaxCallAction()));
  };

export const dispatchrestaurantTablesAction = () => async (dispatch) => {
  dispatch({
    type: FETCH_RESTAURANT_TABLES,
    restaurantTables: {},
  });
};

/**
 * Action to export Guest List
 * @param {*} accessToken
 * @param {*} exportGuestListReqBody
 */
export const exportGuestListAction =
  ({ accessToken, exportGuestListReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await exportGuestListApi({ accessToken, exportGuestListReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

/**
 * Action to export Order History
 * @param {*} accessToken
 * @param {*} exportOrderHistoryReqBody
 */
export const exportOrderHistoryAction =
  ({ accessToken, exportOrderHistoryReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await exportOrderHistoryApi({ accessToken, exportOrderHistoryReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

/**
 * Action to export Order History
 * @param {*} accessToken
 * @param {*} exportOrderItemsReportReqBody
 */
export const exportOrderItemsReportAction =
  ({ accessToken, exportOrderItemsReportReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await exportOrderItemsReportApi({ accessToken, exportOrderItemsReportReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateRestaurantAdditionalChargesAction =
  ({ accessToken, updateRestaurantAdditionalChargesReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateRestaurantAdditionalChargesAPIResponse =
        await updateRestaurantAdditionalChargesApi({
          accessToken,
          updateRestaurantAdditionalChargesReqBody,
        })
          .then((response) => {
            dispatch({
              type: UPDATE_RESTAURANT_ADDITIONAL_CHARGES,
              additionalCharge: get(response, 'data', {}),
            });
            return response;
          })
          .catch((errorResponse) => {
            dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
            return get(errorResponse, 'response', {});
          });

      return updateRestaurantAdditionalChargesAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const addRestaurantAdditionalChargesAction =
  ({ accessToken, addRestaurantAdditionalChargesReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const addRestaurantAdditionalChargesAPIResponse = await addRestaurantAdditionalChargesApi({
        accessToken,
        addRestaurantAdditionalChargesReqBody,
      })
        .then((response) => {
          dispatch({
            type: ADD_RESTAURANT_ADDITIONAL_CHARGES,
            additionalCharges: get(response, 'data.restaurantAdditionalCharges', []),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return addRestaurantAdditionalChargesAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const deleteRestaurantAdditionalChargesAction =
  ({ accessToken, additionalChargeId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const deleteRestaurantAdditionalChargesAPIResponse =
        await deleteRestaurantAdditionalChargesApi({ accessToken, additionalChargeId })
          .then((response) => {
            dispatch({
              type: DELETE_RESTAURANT_ADDITIONAL_CHARGES,
              additionalChargeId,
            });
            return response;
          })
          .catch((errorResponse) => {
            dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
            return get(errorResponse, 'response', {});
          });

      return deleteRestaurantAdditionalChargesAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchRestaurantNotificationEmailsAction = (restaurantId) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const restaurantNotificationEmailsAPIResponse = await fetchRestaurantNotificationEmailsApi(
      restaurantId,
    )
      .then((response) => {
        dispatch({
          type: UPDATE_RESTAURANT_NOTIFICATION_EMAILS,
          restaurantNotificationEmail: get(response, 'data.restaurantNotificationEmails', []),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return restaurantNotificationEmailsAPIResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const updateRestaurantNotificationEmailsAction =
  ({ accessToken, updateRestaurantNotificationEmailsReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateRestaurantNotificationEmailsAPIResponse =
        await updateRestaurantNotificationEmailsApi({
          accessToken,
          updateRestaurantNotificationEmailsReqBody,
        })
          .then((response) => {
            dispatch({
              type: UPDATE_RESTAURANT_NOTIFICATION_EMAILS,
              restaurantNotificationEmail: get(response, 'data.restaurantNotificationEmails', []),
            });
            return response;
          })
          .catch((errorResponse) => {
            dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
            return get(errorResponse, 'response', {});
          });

      return updateRestaurantNotificationEmailsAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchGuestListAction = (accessToken, url, guestSearchReqBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const guestsList = await fetchGuestListApi({ accessToken, url, guestSearchReqBody })
      .then((response) => {
        dispatch({
          type: GET_GUESTS_LIST,
          guestsList: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return guestsList;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const fetchOfferGuestsAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const offerGuests = await fetchOfferGuestApi({ accessToken, url })
      .then((response) => {
        dispatch({
          type: FETCH_OFFER_GUESTS,
          offerGuests: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return offerGuests;
  } catch (err) {
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearOfferGuestsAction = () => async (dispatch) => {
  dispatch({
    type: FETCH_OFFER_GUESTS,
    offerGuests: {},
  });
};

export const creatUpsellItemAction =
  ({ upsellMenuItemObj }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      let response = await creatUpsellItemApi({ upsellMenuItemObj })
        .then((response) => {
          const isItemInclude = false;
          dispatch(
            getRestaurantUpsellAction(get(response, 'data.restaurantId', ''), isItemInclude),
          );
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getUpsellItemAction = (url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const upsellItemList = await getUpsellDataApi({ url })
      .then((response) => {
        dispatch({
          type: GET_UPSELL_ITEM,
          upsellItemList: response,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return upsellItemList;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const updateUpsellItemsAction = (updatedUpsellItemList) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const updatedUpsellItems = await updateUpsellItemsApi({ updatedUpsellItemList })
      .then((response) => {
        const isItemInclude = false;
        dispatch(getRestaurantUpsellAction(get(response, 'data.restaurantId', ''), isItemInclude));
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return updatedUpsellItems;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const getRestaurantUpsellAction = (restaurantId, includeItems) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const restaurantUpsell = await getRestaurantUpsellApi({ restaurantId, includeItems })
      .then((response) => {
        dispatch({
          type: GET_RESTAURANT_UPSELL,
          restaurantUpsell: get(response, 'data', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return restaurantUpsell;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearUpsellDataAction = () => async (dispatch) => {
  dispatch({
    type: GET_UPSELL_ITEM,
    upsellItemList: {},
  });
};

export const fetchRestaurantCashCardAction = (restaurantId) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const cashCardResponse = await fetchRestaurantCashCardApi({ restaurantId })
      .then((response) => {
        dispatch({
          type: FETCH_RESTAURANT_CASH_CARD,
          cashCard: get(response, 'data', []),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return cashCardResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const createRestaurantCashCardAction =
  (restaurantCashCardObj, restaurantId) => async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const restaurantCashCard = await createRestaurantCashCardApi({ restaurantCashCardObj })
        .then((response) => {
          dispatch(fetchRestaurantCashCardAction(restaurantId));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return restaurantCashCard;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateRestaurantCashCardAction =
  ({ restaurantCashCardObj, restaurantId, cashCardId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const restaurantCashCard = await updateRestaurantCashCardApi({
        restaurantCashCardObj,
        cashCardId,
      })
        .then((response) => {
          dispatch(fetchRestaurantCashCardAction(restaurantId));
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return restaurantCashCard;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchCardListAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const cardListResponse = await fetchCardListApi({ accessToken, url })
      .then((response) => {
        dispatch({
          type: FETCH_CARD_LIST,
          cardList: get(response, 'data', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return cardListResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearCardListAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CARD_LIST,
  });
};

export const fetchGuestCashCardDetailsAction =
  ({ accessToken, guestCashCardId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const cardDetailsResponse = await fetchGuestCashCardDetailsApi({
        accessToken,
        guestCashCardId,
      })
        .then((response) => {
          dispatch({
            type: FETCH_CARD_DETAILS,
            cardDetails: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return cardDetailsResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearGuestCashCardDetailsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CARD_DETAILS,
  });
};

export const fetchGuestCashCardTransactionsAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const guestCashCardTransactionsResponse = await fetchGuestCashCardTransactionsApi({
      accessToken,
      url,
    })
      .then((response) => {
        dispatch({
          type: FETCH_GUEST_CASH_CARD_TRANSACTIONS,
          guestCashCardTransactions: get(response, 'data', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return guestCashCardTransactionsResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearGuestCashCardTransactionsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GUEST_CASH_CARD_TRANSACTIONS,
  });
};

export const checkFeaturesStatusAction =
  ({ restaurantId, featuresArr }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const checkFeaturesStatusResponse = await checkFeaturesStatusApi({
        restaurantId,
        featuresArr,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return checkFeaturesStatusResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const dispatchFeaturesStatusAction = (featuresStatusArr) => async (dispatch) => {
  dispatch({
    type: GET_RESTAURANT_UPSELL,
    restaurantUpsell: getFeatureStatus(featuresStatusArr, 'upsell'),
  });
  dispatch({
    type: FETCH_RESTAURANT_CASH_CARD,
    cashCard: [getFeatureStatus(featuresStatusArr, 'cashcard')],
  });
};

export const findGuestByPhoneNumberAction =
  ({ phoneNumber, restaurantId, depthParam }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const findGuestByPhoneNumberAPIResponse = await findGuestByPhoneNumberApi({
        phoneNumber,
        restaurantId,
        depthParam,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return findGuestByPhoneNumberAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const sendOtpAction =
  ({ phoneNumber, countryCode, res }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const sendOtpAPIResponse = await sendOtpApi({
        phoneNumber,
        countryCode,
        res,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return sendOtpAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const createNewGuestAction =
  ({ createNewGuestReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const createNewGuestAPIResponse = await createNewGuestApi({
        createNewGuestReqBody,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return createNewGuestAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const addNewGuestCashCardAction =
  ({ addNewGuestCashCardReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const addNewGuestCashCardAPIResponse = await addNewGuestCashCardApi({
        addNewGuestCashCardReqBody,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return addNewGuestCashCardAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const rechargeGuestCashCardAction =
  ({ rechargeGuestCashCardReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const rechargeGuestCashCardAPIResponse = await rechargeGuestCashCardApi({
        rechargeGuestCashCardReqBody,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rechargeGuestCashCardAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateGuestDetailsAction =
  ({ guestId, updateGuestDetailsReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateGuestDetailsAPIResponse = await updateGuestDetailsApi({
        guestId,
        updateGuestDetailsReqBody,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return updateGuestDetailsAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchOrderCancellationReasonsAction =
  ({ restaurantId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const orderCancellationReasons = await fetchOrderCancellationReasonsApi({ restaurantId })
        .then((response) => {
          dispatch({
            type: FETCH_ORDER_CANCELLATION_REASONS,
            orderCancellationReasons: get(response, 'data.cancelReasons', []),
          });
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return orderCancellationReasons;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearOrderCancellationReasonsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ORDER_CANCELLATION_REASONS,
  });
};

export const fetchRestaurantSubscriptionDetailsAction =
  ({ restaurantId, restaurantAttributesDepth, userGroupId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const fetchRestaurantSubscriptionAPIResponse = await fetchRestaurantSubscriptionApi({
        restaurantId,
        restaurantAttributesDepth,
        userGroupId,
      })
        .then((response) => {
          const restaurantSubscriptions = response?.data ?? [];
          const activeSubscription =
            restaurantSubscriptions.find((subscription) => subscription?.isActive) ?? {};
          dispatch({
            type: FETCH_RESTAURANT_SUBSCRIPTION_DETAILS,
            subscriptionDetails: activeSubscription,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return fetchRestaurantSubscriptionAPIResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearRestaurantSubscriptionDetailsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_RESTAURANT_SUBSCRIPTION_DETAILS,
  });
};

export const fetchRestaurantSubscriptionPlanHistoryAction =
  (subscriptionId) => async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const fetchRestaurantSubscriptionHistoryAPIResponse =
        await fetchRestaurantSubscriptionHistoryApi({ subscriptionId })
          .then((response) => {
            const subscriptionPlanHistory = response?.data?.subscriptionPlans ?? [];
            dispatch({
              type: FETCH_RESTAURANT_SUBSCRIPTION_PLAN_HISTORY,
              subscriptionPlanHistory,
            });
            return response;
          })
          .catch((errorResponse) => {
            dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
            return get(errorResponse, 'response', {});
          });

      return fetchRestaurantSubscriptionHistoryAPIResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearRestaurantSubscriptionPlanHistoryAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_RESTAURANT_SUBSCRIPTION_PLAN_HISTORY,
  });
};

export const fetchSaaSPlansAction = () => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const fetchSaaSPlansApiResponse = await fetchSaaSPlansApi()
      .then((response) => {
        const saasPlans = response?.data?.plans ?? [];
        dispatch({
          type: FETCH_SAAS_PLANS,
          saasPlans,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return fetchSaaSPlansApiResponse;
  } catch (err) {
    console.error(err);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const fetchProgressiveWebAppDataAction =
  ({ subDomain }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const progressiveWebAppDataAPIResponse = await fetchProgressiveWebAppDataApi({ subDomain })
        .then((response) => {
          dispatch({
            type: DISPATCH_PROGRESSIVE_WEB_APP_DATA,
            progressiveWebApp: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return progressiveWebAppDataAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const createProgressiveWebAppAction =
  ({ progressiveWebAppReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const createProgressiveWebAppAPIResponse = await createProgressiveWebAppApi({
        progressiveWebAppReqBody,
      })
        .then((response) => {
          dispatch({
            type: DISPATCH_PROGRESSIVE_WEB_APP_DATA,
            progressiveWebApp: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return createProgressiveWebAppAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const updateProgressiveWebAppAction =
  ({ progressiveWebAppReqBody, appId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateProgressiveWebAppAPIResponse = await updateProgressiveWebAppApi({
        progressiveWebAppReqBody,
        appId,
      })
        .then((response) => {
          dispatch({
            type: DISPATCH_PROGRESSIVE_WEB_APP_DATA,
            progressiveWebApp: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return updateProgressiveWebAppAPIResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearProgressiveWebAppDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_PROGRESSIVE_WEB_APP_DATA,
  });
};

export const registerSubscriptionRequestAction =
  ({ requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const registerSubscriptionRequestResponse = await registerSubscriptionRequestApi({
        requestBody,
      })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return registerSubscriptionRequestResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const goLiveRestaurantAction =
  ({ restaurantId, accessToken, checklist, depthParam }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const requestBody = { restaurantId, checklist };
      let response = await goLiveRestaurantApi({ requestBody })
        .then((response) => {
          dispatch(
            getRestaurantDataAction({
              restaurantId,
              accessToken,
              depthParam,
            }),
          );
          return response;
        })
        .catch((errorResponse) => get(errorResponse, 'response', {}));
      return response;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const getEntityMappingDataAction = (requestBody) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());
    const entityMappingRequestResponse = await getEntityMappingDataApi(requestBody)
      .then((responseBody) => {
        dispatch({
          type: GET_ENTITY_MAPPING_DATA,
          entityMapping: responseBody?.data ?? {},
        });

        return responseBody;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return entityMappingRequestResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const updateEntityMappingDataAction =
  ({ restaurantCode, requestBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const updateEntityMappingDataResponse = await updateEntityMappingDataApi({
        restaurantCode,
        requestBody,
      })
        .then((responseBody) => responseBody)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return updateEntityMappingDataResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearEntityMappingDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_ENTITY_MAPPING_DATA,
  });
};

export const fetchPOSSyncStatusByOrderIdsAction =
  ({ restaurantCode, orderIds }) =>
  async (dispatch) => {
    try {
      let posSyncResponse = await fetchPOSSyncStatusByOrderIdsApi({ restaurantCode, orderIds })
        .then((response) => {
          dispatch({
            type: FETCH_POS_SYNC_STATUS_BY_ORDER_IDS,
            currentPOSSyncStatus: response?.data ?? [],
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return posSyncResponse;
    } catch (error) {
      console.error(error);
    }
  };

export const dispatchCurrentPOSSyncStatusAction = (currentPOSSyncStatus) => async (dispatch) => {
  dispatch({
    type: DISPATCH_POS_SYNC_STATUS,
    currentPOSSyncStatus,
  });
};

export const clearPOSSyncStatusByOrderIdsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_POS_SYNC_STATUS_BY_ORDER_IDS,
  });
};

export const getRestaurantPosIntegrationAction =
  ({ restaurantCode, integrationType }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const restaurantPosIntegrationsResponse = await getRestaurantIntegrationsApi({
        restaurantCode,
      })
        .then((responseBody) => {
          const posIntegrationProperties = responseBody?.data?.find((integration) =>
            isEqual(integration?.integrationType, integrationType),
          );
          dispatch({
            type: GET_RESTAURANT_POS_INTEGRATIONS,
            posIntegrationProperties,
          });
          return responseBody;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return restaurantPosIntegrationsResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearRestaurantPosIntegrationAction = () => async (dispatch) => {
  dispatch({
    type: ClEAR_RESTAURANT_POS_INTEGRATIONS,
  });
};

export const clearRestaurantIntegrations = () => async (dispatch) => {
  dispatch({
    type: CLEAR_RESTAURANT_INTEGRATIONS,
  });
};

export const fetchBulkPOSSyncEventsAction = (accessToken, url) => async (dispatch) => {
  try {
    dispatch(beginAjaxCallAction());

    const bulkPOSSyncEventsResponse = await fetchBulkPOSSyncEventsApi({
      url,
    })
      .then((response) => {
        dispatch({
          type: FETCH_BULK_POS_SYNC_EVENTS,
          bulkPOSSyncEvents: response?.data ?? {},
        });

        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });

    return bulkPOSSyncEventsResponse;
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(endAjaxCallAction());
  }
};

export const clearBulkPOSSyncEventsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_BULK_POS_SYNC_EVENTS,
  });
};

export const fetchExternalPOSMenuItemsAction =
  ({ restaurantCode, externalSystemId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const fetchExternalPOSMenuItemsResponse = await fetchExternalPOSMenuItemsApi({
        restaurantCode,
        externalSystemId,
      })
        .then((response) => {
          dispatch({
            type: FETCH_EXTERNAL_POS_MENU_ITEMS,
            externalPOSMenuItems: response?.data ?? [],
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return fetchExternalPOSMenuItemsResponse;
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

// Engage Specific Actions

export const validateCouponAction =
  ({ validateCouponReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const validateCouponResponse = await validateCouponApi({ validateCouponReqBody })
        .then((response) => {
          const validateDeal = get(response, 'data', {});
          dispatch({
            type: VALIDATE_DEAL_DATA,
            validateDeal,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return validateCouponResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const redeemCouponAction =
  ({ redeemCouponReqBody }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const redeemCouponResponse = await redeemCouponApi({ redeemCouponReqBody })
        .then((response) => {
          const redeemedDeal = get(response, 'data', {});
          dispatch({
            type: REDEEMED_DEAL_DATA,
            redeemedDeal,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return redeemCouponResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const clearRedeemedDealAction = () => async (dispatch) => {
  dispatch({
    type: REDEEMED_DEAL_DATA,
    redeemedDeal: {},
  });
};

export const clearValidateDealAction = () => async (dispatch) => {
  dispatch({
    type: VALIDATE_DEAL_DATA,
    validateDeal: {},
  });
};
